import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext({
  me: null,
  setMe: () => {},
  likes: [],
  setLikes: () => {},
  refreshMe: async () => null,
  loading: true,
});

const fetchMe = async () => {
  const res = await fetch('/api/me', {
    credentials: 'include',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    throw new Error(`me_failed_${res.status}`);
  }

  const json = await res.json();
  return json?.data?.user || null;
};

const fetchLikes = async () => {
  const res = await fetch('/api/me/likes', {
    credentials: 'include',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 401) {
    return [];
  }

  if (!res.ok) {
    throw new Error(`likes_failed_${res.status}`);
  }

  const json = await res.json();

  if (Array.isArray(json)) {
    return json;
  }

  if (Array.isArray(json?.data)) {
    return json.data;
  }

  return [];
};

export const AuthProvider = ({ children }) => {
  const [me, setMe] = useState(null);
  const [likes, setLikes] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    try {
      const user = await fetchMe();
      setMe(user);

      if (user) {
        const likeRows = await fetchLikes();
        const nextLikes = Array.isArray(likeRows)
          ? likeRows
              .map(row => row?.listingId || row?.listing_id || row?.product_id || row)
              .filter(Boolean)
          : [];
        setLikes(nextLikes);
      } else {
        setLikes([]);
      }

      return user;
    } catch (e) {
      setMe(null);
      setLikes([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshMe();
  }, []);

  return (
    <AuthContext.Provider value={{ me, setMe, likes, setLikes, refreshMe, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);